module.exports = __webpack_public_path__ + "static/img/smith-farm-historical-signs18.ae15bd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/smith-farm/smith-farm-historical-signs18.jpg
// module id = 973
// module chunks = 0